import { message } from 'antd';
import { NavigateFunction } from 'react-router-dom';
import { videoSourceService } from '../service/videoSourceService';

interface VideoSourceHandlersProps {
  navigate: NavigateFunction;
}

interface VideoSourceHandlersReturn {
  onClickDeleteButton: (id: number) => Promise<void>;
  onClickTitleButton: (id: number) => void;
  onClickSettingButton: (id: number) => void;
  onClickReloadButton: (id: number) => void;
  handleAddClick: () => void;
}

export const getVideoSourceHandlers = ({
  navigate,
}: VideoSourceHandlersProps): VideoSourceHandlersReturn => {
  const onClickDeleteButton = async (id: number): Promise<void> => {
    // message.info(`You do not have permission to delete video source with id ${id}`);
    const isConfirmed = window.confirm('Are you sure you want to delete the selected items?');
    if (!isConfirmed) return;
    await videoSourceService.delete(id);
    window.location.reload();
  };

  const onClickTitleButton = (id: number): void => {
    navigate(`/video-source/edit/${id}`);
  };

  const onClickSettingButton = (id: number): void => {
    navigate(`/video-source/edit/${id}`);
  };

  const onClickReloadButton = (id: number): void => {
    videoSourceService
      .generate(id)
      .then(() => {
        message.success(
          `데이터 불러오기를 시작했습니다.
           시간이 다소 걸릴 수 있습니다.`,
          5
        );
      })
      .catch(() => {
        message.error(
          `데이터 불러오기에 실패했습니다.
           prj-mediahub 채널에 문의하세요.`,
          5
        );
      });
  };

  const handleAddClick = (): void => {
    navigate('/video-source/edit');
  };

  return {
    onClickDeleteButton,
    onClickTitleButton,
    onClickSettingButton,
    onClickReloadButton,
    handleAddClick,
  };
};
